import type { SupportStatusValue } from '@/api/supportApi'
import { STATUS_LABEL, statusTone, type StatusTone } from '@/lib/support/supportView'
import { cn } from '@/lib/utils'

const TONE: Record<StatusTone, string> = {
  waiting: 'bg-amber-50 text-amber-700',
  progress: 'bg-blue-50 text-blue-700',
  done: 'bg-emerald-50 text-emerald-700',
  neutral: 'bg-muted text-muted-foreground',
}

export function SupportStatusPill({ status }: { status: SupportStatusValue }) {
  return (
    <span className={cn('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold', TONE[statusTone(status)])}>
      {statusTone(status) === 'done' ? '✓' : '●'} {STATUS_LABEL[status] ?? status}
    </span>
  )
}
